//JS file

import { initBackToTop } from '../storybook/js/back-to-top.js';
import "./components/filter";
import "./components/navigation";
import "./components/search-form";

document.addEventListener('DOMContentLoaded', () => {
    initBackToTop();
});